<template lang="pug">
.image-placeholder(aria-hidden='true')
  img.image-placeholder__logo(:src='logoSrc', alt='')
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    logoSrc?: string
  }>(),
  {
    logoSrc: '/media/brand/icon-square-white.png',
  },
)
</script>

<style scoped>
.image-placeholder {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  min-height: 100%;
  padding: var(--image-placeholder-padding, 1.2rem);
  background: var(--image-placeholder-background, white);
}

.image-placeholder__logo {
  display: block;
  width: min(
    var(--image-placeholder-logo-width, 72%),
    var(--image-placeholder-logo-max-width, 8rem)
  );
  height: auto;
  opacity: var(--image-placeholder-logo-opacity, 0.32);
  filter: blur(var(--image-placeholder-logo-blur, 1.2px));
}
</style>
